// PdfIcon.js
import React from "react";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

const PdfIcon = ({ style }) => (
 <center> <PictureAsPdfIcon style={{ color: 'red', fontSize: 75,width:45}} /></center>
);

export default PdfIcon;
